'use client'

import { type ReactNode } from 'react'
import { usePathname } from 'next/navigation'
import { LoginModalProvider } from '@/context/LoginModalContext'
import { SupportProvider } from '@/context/SupportContext'
import { SupportFabMinimal } from '@/app/components/support/SupportFab.minimal'
import { SUPPORT_FEATURE_ENABLED } from '@/lib/config'

export default function SupportWidget({ children }: { children: ReactNode }) {
  const pathname = usePathname()
  const isFinanceRoute = pathname?.startsWith('/finance')
  const isRecruiterSummaryRoute = pathname?.startsWith('/recruiter/interviews')
  const isAdminRoute = pathname?.startsWith('/admin')
  const isMarketingRoute = pathname?.startsWith('/marketing')
  const isInterviewRoute = pathname?.startsWith('/interview') || pathname?.startsWith('/jd-interview')
  const isConsentRoute = pathname?.startsWith('/enterprise/interview-consent')

  const showSupport =
    SUPPORT_FEATURE_ENABLED &&
    !isFinanceRoute &&
    !isRecruiterSummaryRoute &&
    !isAdminRoute &&
    !isInterviewRoute &&
    !isConsentRoute &&
    !isMarketingRoute

  // LoginModalProvider stays mounted on every route. Returning before it rendered took the
  // provider away along with the widget, and /jd-interview calls useLoginModal() at the top
  // of the component - so excluding that route made the hook throw during static
  // prerendering and failed `next build`. Route gating belongs to the support UI only.
  return (
    <LoginModalProvider>
      {showSupport ? (
        <SupportProvider>
          {children}
          <SupportFabMinimal />
        </SupportProvider>
      ) : (
        children
      )}
    </LoginModalProvider>
  )
}
